import { accountApi } from "./accountApi";
import { actionIdentifiersApi } from "./actionIdentifiersApi";
import { alertsApi } from "./alertsApi";
import { actionsApi } from "./actionsApi";
import { authApi } from "./authApi";
import { biocycleApi } from "./biocycleApi";
import { chartsApi } from "./chartsApi";
import { chatbotApi } from "./chatbotApi";
import { collabApi } from "./collabApi";
import { cropsApi } from "./cropsApi";
import { emissionsApi } from "./emissionsApi";
import { enemiesApi } from "./enemiesApi";
import { equipmentsApi } from "./equipmentsApi";
import { fieldAnalysisApi } from "./fieldAnalysisApi";
import { fieldsApi } from "./fieldsApi";
import { filtersApi } from "./filtersApi";
import { generalAgroApi } from "./generalAgroApi";
import { inboxApi } from "./inboxApi";
import { invoicesApi } from "./invoicesApi";
import { kaekApi } from "./kaekApi";
import { labelsApi } from "./labelsApi";
import { messagesApi } from "./messagesApi";
import { newsFeedApi } from "./newsFeedApi";
import { opekepeApi } from "./opekepeApi";
import { paymentsApi } from "./paymentsApi";
import { satelliteApi } from "./satelliteApi";
import { settingsApi } from "./settingsApi";
import { stressesApi } from "./stressesApi";
import { supersetApi } from "./supersetApi";
import { usersApi } from "./usersApi";
import { weatherApi } from "./weatherApi";

const endpoints = {
  account: accountApi,
  alerts: alertsApi,
  actions: actionsApi,
  actionIdentifiers: actionIdentifiersApi,
  auth: authApi,
  biocycle: biocycleApi,
  charts: chartsApi,
  chatbot: chatbotApi,
  collab: collabApi,
  crops: cropsApi,
  emissions: emissionsApi,
  enemies: enemiesApi,
  equipments: equipmentsApi,
  fieldAnalysis: fieldAnalysisApi,
  fields: fieldsApi,
  filters: filtersApi,
  inbox: inboxApi,
  invoices: invoicesApi,
  labels: labelsApi,
  opekepe: opekepeApi,
  payments: paymentsApi,
  generalAgro: generalAgroApi,
  kaek: kaekApi,
  messages: messagesApi,
  newsFeed: newsFeedApi,
  satellite: satelliteApi,
  settings: settingsApi,
  stresses: stressesApi,
  superset: supersetApi,
  users: usersApi,
  weather: weatherApi,
};

export default endpoints;
